// package imports
import React, { useEffect } from 'react';
import { ColorRing } from 'react-loader-spinner';
import { Portal } from 'react-portal';

// CSS imports
import './Modal.css';

// Type imports
import { ModalSize } from '../../types/modal/ModalSize';

type Props = {
  children?: React.ReactNode;
  showModal: boolean;
  size?: ModalSize;
  isLoading?: boolean;
  dismissBlocked?: boolean;
  setShowModal: (x: boolean) => void;
};

const Modal: React.FC<Props> = ({
  children,
  showModal,
  size,
  isLoading,
  dismissBlocked,
  setShowModal,
}: Props) => {
  useEffect(() => {
    if (showModal) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'scroll';
    }
  }, [showModal]);

  const closeModal = () => {
    if (!dismissBlocked) {
      setShowModal(false);
      document.body.style.overflow = 'scroll';
    }
  };
  return showModal ? (
    <Portal>
      <div className='ModalBackground' onClick={closeModal}></div>
      <div
        className={`Modal ${
          size === ModalSize.SMALL
            ? 'small-modal'
            : size === ModalSize.LARGE
            ? 'large-modal'
            : ''
        }`}
      >
        {children}
      </div>
      {isLoading ? (
        <div className='ModalLoader'>
          <ColorRing
            visible={true}
            height='80'
            width='80'
            ariaLabel='color-ring-loading'
            wrapperStyle={{}}
            wrapperClass='loader-wrapper'
            colors={['#FFFFFF', '#FFFFFF', '#FFFFFF', '#FFFFFF', '#FFFFFF']}
          />
        </div>
      ) : null}
    </Portal>
  ) : null;
};

export default Modal;
